<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="index()" [steps]="numbers().length" class="block w-full" name="Flits tellen" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Hoeveel stippen tel je?'" />

    <div class="grid place-items-center">
      @if (state() === 'VISIBLE' || state() === 'ANSWER') {
        @for (num of [number()]; track num) {
          @if (state() === 'ANSWER') {
            <h1
              animate.enter="wait-300 anim-pop-in"
              animate.leave="anim-fade-out"
              class="font-family-din pb-8 text-6xl font-black text-emerald-500 drop-shadow-2xl"
            >
              {{ num }}
            </h1>
          }

          <rid-content-card animate.enter="wait-300 anim-pop-in" animate.leave="anim-fade-out" state="DEFAULT">
            <div class="bg-card-background aspect-square size-full w-xl rounded-lg p-4">
              <div class="relative size-full">
                @for (pos of numberPositions(); track $index) {
                  <div [style.left]="pos.x + '%'" [style.top]="pos.y + '%'" class="absolute size-[5%] p-0.5 drop-shadow-md">
                    <div class="size-full rounded-full bg-emerald-500"></div>
                  </div>
                }
              </div>
            </div>
          </rid-content-card>
        }
      }
    </div>

    @if (state() === 'ANSWER') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
